<template>
    <div class="news">
        <div class="container pb-5">
            <div class="row">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <!-- Titulli në anën e majtë -->
                    <!-- <h2 class="headTitle ms-3">{{ tabMenu.title }}</h2> -->
                    <title-area :title="tabMenu.title" />

                    <!-- Nav Tabs në anën e djathtë -->
                    <!-- <ul class="nav nav-tabs me-3" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home"
                                type="button" role="tab" aria-controls="home" aria-selected="true">
                                {{ tabMenu.all }}
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile"
                                type="button" role="tab" aria-controls="profile" aria-selected="false">
                                {{ tabMenu.kpk }}
                            </button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact"
                                type="button" role="tab" aria-controls="contact" aria-selected="false">
                                {{ tabMenu.psh }}
                            </button>
                        </li>
                    </ul> -->
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            
                            <div class="row mt-4">
                                <div class="col-12 col-lg-9 p-0">
                                    <news-template-left :data="formatedLeftData" />
                                </div>
                                <div class="col-12 col-lg-3 p-0">
                                    <news-template-right :data="formatedRightData" />
                                </div>
                            </div>
                    
                        </div>
                        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <!-- Content for KPK tab -->
                        </div>
                        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                            <!-- Content for PSH tab -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 text-center mt-4">
                    <button class="btn btn-primary showall" @click="redirectAll()">{{ tabMenu.all_button }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NewsTemplateLeft from '../share/CardNewsTemplateLeft.vue';
import NewsTemplateRight from '../share/CardNewsTemplateRight.vue';
import { usePostsStore } from '@/store/PostStore/postStore';
import titleArea from '../share/TitleArea.vue';

export default {
    data()
    {
        return {
            postStore: usePostsStore(),
            webPage: '',
            language: 'AL', // Match API case
            count: 6,
            categoryId: 7,
            categoryIdRight: 7,
            countRight: 16,
        };
    },
    components: {
        NewsTemplateLeft,
        NewsTemplateRight,
        titleArea
    },
    computed: {
        formatedLeftData()
        {
            return this.postStore.leftPosts.map(post => ({
                id: post.id,
                data_postimit: post.createdDate,
                titulli: post.priceDetailsTitle,
  
                prokuroria: post.webPage,
                imageUrl: post.pDetailsFileUrl || '/default-image.jpg', // Use relative path or CDN
            }));
        },
        formatedRightData()
        {
            return this.postStore.rightPosts.map(post => ({
                id: post.id,
                data_postimit: post.createdDate,
                titulli: post.priceDetailsTitle,
                prokuroria: post.webPage,
                imageUrl: post.pDetailsFileUrl || '/default-image.jpg', // Optional for right component
            }));
        },
        tabMenu()
        {
            return {
                title: this.$t('sistemi_prokurorial.news.title'),
                all: this.$t('sistemi_prokurorial.news.all'),
                kpk: this.$t('sistemi_prokurorial.news.kpk'), // Add translation key
                psh: this.$t('sistemi_prokurorial.news.psh'), // Add translation key
                all_button: this.$t('sistemi_prokurorial.news.all_button'),
            };
        },
    },
    created()
    {
        this.fetchPostsLeft();
        this.fetchPostsRight();
    },
    methods: {
        fetchPostsLeft()
        {
            const postsData = {
                webPage: this.webPage,
                language: this.language,
                count: this.count,
                categoryId: this.categoryId,
            };
            this.postStore.getPostsLeft(postsData);
        },
        fetchPostsRight()
        {
            const postsData = {
                webPage: this.webPage,
                language: this.language,
                count: this.countRight,
                categoryId: this.categoryIdRight,
            };
            this.postStore.getPostsRight(postsData);
        },

        redirectAll()
        {
            this.$router.push(`/latestnews`);

        }
    },
};
</script>

<style scoped>
.news {
    background-color: #eff2f5;
    padding-top: 40px;
}

.showall {
    background-color: #2c3f5e;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
    color: #0b0a21;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0%;
    background-color: #dde3eb;
    border-bottom: 0;
    border-radius: 6px;
}

.nav-link {
    font-size: 14px;
    color: #0b0a21;
    margin-left: 8px;
}

.nav-tabs {
    border-bottom: 0;
}

.headTitle {
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -1%;
}
@media (max-width: 575.98px) {
  .headTitle {
    margin-left: 0 !important;
  }
  .nav-tabs {
    margin-right: 0 !important;
  }
}
</style>